import React from 'react';
import gql from 'graphql-tag';
import { curry, get, set } from 'lodash';
import { Mutation } from 'react-apollo';

import { removeItemById } from '../utils';
import { query, NAME as REQUEST_LINES_QUERY } from '../withCaseRequestLines';
import { CASE_REQUEST_ASSETS_QUERY_NAME } from '../../RequestAssetsForm/withRequestAssets/caseRequestAssetsQuery';

const NAME = 'compositions_CaseRequestPanel_DeleteRequestLines';

const mutation = gql`
  mutation ${NAME} ($id: ID!) {
    deleteCaseRequestLine(input: { ids: [$id] }) {
      deletedCount
    }
  }
`;

const buildMutationChild = curry((WrappedComponent, componentProps, mutate) => {
  const deleteRequestedLine = id =>
    mutate({
      variables: { id },
      optimisticResponse: {
        deleteCaseRequestLine: {
          __typename: 'OperatingDelete',
          deletedCount: 1,
        },
      },
      update: (store, { data }) => {
        const variables = { caseNumber: componentProps.caseNumber };
        const cache = store.readQuery({ query, variables });
        const lines = removeItemById(get(cache, 'case.requestLines', []), id);

        store.writeQuery({
          query,
          data: set(cache, 'case.requestLines', lines),
          variables,
        });
      },
    });

  return (
    <WrappedComponent
      {...componentProps}
      deleteRequestedLine={deleteRequestedLine}
    />
  );
});

const withCaseDeleteRequestLines = WrappedComponent => componentProps => (
  <Mutation
    mutation={mutation}
    refetchQueries={[REQUEST_LINES_QUERY, CASE_REQUEST_ASSETS_QUERY_NAME]}
  >
    {buildMutationChild(WrappedComponent, componentProps)}
  </Mutation>
);

export default withCaseDeleteRequestLines;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestLinesActions/withCaseDeleteRequestLines.js